import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Play, Calendar, Star } from 'lucide-react';
export function Highlights() {
  const highlights = [{
    title: 'Competition Photos',
    icon: <Camera size={24} data-id="element-130" />,
    type: 'Gallery'
  }, {
    title: 'Training Highlights',
    icon: <Play size={24} data-id="element-131" />,
    type: 'Video'
  }, {
    title: 'Recent Events',
    icon: <Calendar size={24} data-id="element-132" />,
    type: 'Update'
  }, {
    title: 'Sponsor Updates',
    icon: <Star size={24} data-id="element-133" />,
    type: 'News'
  }];
  return <section id="highlights" className="py-20 lg:py-28 bg-usa-gray" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-display font-bold text-usa-navy mb-6" data-id="element-137">
            CYRUS' RECENT HIGHLIGHTS
          </motion.h2>
          <div className="w-16 h-1 bg-usa-red mx-auto" data-id="element-138" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 max-w-5xl mx-auto" data-id="element-139">
          <div className="text-center mb-6" data-id="element-140">
            <span className="text-xs font-bold text-usa-red uppercase tracking-widest block mb-2" data-id="element-141">
              Featured Video
            </span>
            <h3 className="font-display text-2xl md:text-3xl text-usa-navy" data-id="element-142">
              Watch Cyrus In Action
            </h3>
          </div>
          <div className="relative w-full aspect-video bg-usa-navy shadow-2xl border-4 border-usa-navy overflow-hidden" data-id="element-143">
            <iframe src="https://www.youtube.com/embed/4NF03B1okTk" title="Cyrus Barbour Taekwondo Highlights" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-144" />
          </div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-145">
          {highlights.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white group cursor-pointer border border-gray-200 hover:border-usa-blue transition-colors overflow-hidden" data-id="element-146">
              <div className="aspect-[4/3] bg-gray-100 flex items-center justify-center text-gray-300 group-hover:bg-usa-navy group-hover:text-usa-gold transition-colors" data-id="element-147">
                {item.icon}
              </div>
              <div className="p-6" data-id="element-148">
                <span className="text-xs font-bold text-usa-red uppercase tracking-wider mb-2 block" data-id="element-149">
                  {item.type}
                </span>
                <h3 className="font-display text-xl text-usa-navy" data-id="element-150">
                  {item.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}